import { Box, Grid, Typography, Paper, List, ListItem, ListItemText, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Button, TextField, Select, MenuItem, FormControl, InputLabel, Avatar } from '@mui/material';
import { 
	BooleanInput, 
	Edit, 
	NumberInput, 
	SimpleForm, 
	TextInput,
	useRecordContext,
	ImageField,
	ImageInput,
	useNotify,
	useGetRecordId
} from 'react-admin';
import constants from '../../constants';

import { useState, useEffect, useMemo } from 'react';
import { Person, ArrowForward, ArrowBack, Email, GetApp, DeleteOutline, Add } from '@mui/icons-material';
import axios from 'axios';
import { useParams } from 'react-router-dom';

const getMemberIdentifier = (member: any): string => {
	if (!member) return '';
	if (typeof member === 'object') {
		return member._id || member.id || member.email || JSON.stringify(member);
	}
	return String(member);
};

const DatingEventEdit = () => {
	const notify = useNotify();
	// Get the record context to ensure form re-renders with data
	const record = useRecordContext();
	const [registeredUsers, setRegisteredUsers] = useState<any[]>([]);
	const [waitingUsers, setWaitingUsers] = useState<any[]>([]);

	useEffect(() => {
		console.log('DatingEventEdit: Record data loaded:', record);
	}, [record]);
	// Demo data for testing
	const demoUsers = [
		{
			"_id": "68ad91d963a852f6e908f207",
			"company": {
				"_id": "62f4da77454b14d740800af3",
				"english_name": "GroupHug",
				"id": "62f4da77454b14d740800af3"
			},
			"createdAt": "2025-08-26T10:52:09.950Z",
			"dateOfBirth": "2015-12-11T22:00:00.000Z",
			"email": "uritest@grouphug.online",
			"first_name": "Ttt",
			"id": "68ad91d963a852f6e908f207",
			"last_name": "Ttt"
		},
		{
			"_id": "67dac31ac0fd9419998c2301",
			"company": {
				"_id": "62f4da77454b14d740800af3",
				"english_name": "GroupHug",
				"id": "62f4da77454b14d740800af3"
			},
			"createdAt": "2025-06-26T13:14:02.940Z",
			"dateOfBirth": "2020-11-10T21:39:06.000Z",
			"dating_profile": {
				"deal_break": "מעשנת",
				"description": "אוהב בעלי חיים",
				"interests": "גברים",
				"want_to_get_known_for": "מחוץ לארגון/חברה שלי"
			},
			"email": "uri.i@grouphug.online",
			"first_name": "urii",
			"id": "67dac31ac0fd9419998c2301",
			"last_name": "izhaki"
		}
	];

	const [invitationList, setInvitationList] = useState<any[]>([]);
	const [invitationWatingList, setInvitationWatingList] = useState<any[]>([]);
	const [invitationConfirmedList, setInvitationConfirmedList] = useState<any[]>([]);
	const [invitationMatchedList, setInvitationMatchedList] = useState<any[]>([]);
	const [externalRegisters, setExternalRegisters] = useState<any[]>([]);
	const combinedInvitationMembers = useMemo(() => {
		const seen = new Map<string, any>();
		const addMember = (member: any) => {
			if (!member) return;
			const key = getMemberIdentifier(member);
			if (!seen.has(key)) {
				seen.set(key, member);
			}
		};

		(invitationList || []).forEach(addMember);
		(invitationConfirmedList || []).forEach(addMember);

		return Array.from(seen.values());
	}, [invitationList, invitationConfirmedList]);
	const matchedMemberIds = useMemo(() => {
		const ids = new Set<string>();
		(invitationMatchedList || []).forEach(match => {
			if (match?.memberId) ids.add(String(match.memberId));
			if (match?.memberMatchId) ids.add(String(match.memberMatchId));
		});
		return ids;
	}, [invitationMatchedList]);
    const { id } = useParams();
	// Function to get user display name
	const getUserDisplayName = (user: any) => {
		if (user.first_name && user.last_name) {
			return `${user.first_name} ${user.last_name}`;
		}
		return user.email || `משתמש ${user._id?.slice(-4) || 'לא ידוע'}`;
	};

	// Function to get user details
	const getUserDetails = (user: any) => {
		const details = [];
		if (user.email) details.push(user.email);
		if (user.company?.english_name) details.push(user.company.english_name);
		if (user.dating_profile?.interests) details.push(user.dating_profile.interests);
		return details.join(' • ') || 'אין פרטים נוספים';
	};

	// Function to calculate gender statistics
	const getGenderStats = () => {
		const allUsers = [
			...(invitationList || []),
			...(invitationWatingList || []),
			...(invitationConfirmedList || [])
		];
		
	
		const maleUsers = allUsers.filter(user => user.gender === 'M');
		const femaleUsers = allUsers.filter(user => user.gender === 'F');
		const noGenderUsers = allUsers.filter(user => !user.gender || (user.gender !== 'M' && user.gender !== 'F'));
		
		console.log('DatingEventEdit: Male users:', maleUsers);
		console.log('DatingEventEdit: Female users:', femaleUsers);
		console.log('DatingEventEdit: No gender users:', noGenderUsers);
		
		const maleEmails = maleUsers.map(user => user.email).filter(Boolean);
		const femaleEmails = femaleUsers.map(user => user.email).filter(Boolean);
		const noGenderEmails = noGenderUsers.map(user => user.email).filter(Boolean);
		
		// Get interests for each gender
		const maleInterests = maleUsers.map(user => user.dating_profile?.interests).filter(Boolean);
		const femaleInterests = femaleUsers.map(user => user.dating_profile?.interests).filter(Boolean);
		const noGenderInterests = noGenderUsers.map(user => user.dating_profile?.interests).filter(Boolean);
		
		return { 
			males: maleUsers.length, 
			females: femaleUsers.length, 
			noGender: noGenderUsers.length,
			total: allUsers.length,
			maleEmails,
			femaleEmails,
			noGenderEmails,
			maleInterests,
			femaleInterests,
			noGenderInterests
		};
	};

	// Function to move user from confirmed list to waiting list
	const moveToWaitingList = (index: number) => {
		const user = invitationList[index];
		setInvitationList(prev => Array.isArray(prev) ? prev.filter((_, i) => i !== index) : []);
		setInvitationWatingList(prev => Array.isArray(prev) ? [...prev, user] : [user]);
		handleMoveToWatingList(user);
	};

	const handleMoveToWatingList = async (user: any) => {
		const { data } = await axios.post(`${constants.API_URL}/dating-events/move-member-to-wating-list/${id}`, {
			memberId: user._id
		});
		console.log('DatingEventEdit: Saved lists:', data);
		
	};

	// Function to move user from waiting list to confirmed list
	const moveToConfirmedList = (index: number) => {
		const user = invitationWatingList[index];
		setInvitationWatingList(prev => prev.filter((_, i) => i !== index));
		setInvitationList(prev => [...prev, user]);

		handleMoveToConfirmedList(user);
	};

	const handleMoveToConfirmedList = async (user: any) => {
		const { data } = await axios.post(`${constants.API_URL}/dating-events/move-member-to-confirm-list/${id}`, {
			
			memberId: user._id
		});
		console.log('DatingEventEdit: Saved lists:', data);
		
	};
	useEffect(() => {
		
		console.log('DatingEventEdit: ID:', id);
		getRegisteredUsers(id || '');
	}, []);

	useEffect(() => {
		// Also check if external_registers is in the record
		if (record?.external_registers) {
			setExternalRegisters(record.external_registers);
		}
	}, [record]);

	const getRegisteredUsers = async (id:string) => {
		// record is undefined because we need to use the useRecordContext hook to access it
		
		const { data } = await axios.get(`${constants.API_URL}/dating-events/events-registered/${id}`);
		console.log('DatingEventEdit', data?.data);
		console.log('invitationList data:', data?.data?.invitationList);
		console.log('external_registers data:', data?.data?.external_registers);
	

		setInvitationList(data?.data?.invitationList);
		setInvitationWatingList(data?.data?.invitationWatingList);
		setInvitationConfirmedList(data?.data?.invitationConfirmList);
		setInvitationMatchedList(data?.data?.invitationMatchedList || []);
		setExternalRegisters(data?.data?.external_registers || record?.external_registers || []);
		return data;
	};

	// Function to save the updated lists
	const saveLists = async() => {
		
		const { data } = await axios.post(`${constants.API_URL}/dating-events/change-lists/68ad7392115b8f712e375bbe`, {
			invitationList: invitationList?.map(user => user._id) || [],
			waitingList: invitationWatingList?.map(user => user._id) || []
		});
		console.log('DatingEventEdit: Saved lists:', data);
		

	};

	const sendEmail = async (index: number) => {
		const user = invitationWatingList[index];
		const { data } = await axios.post(`${constants.API_URL}/dating-events/send-email-to-member-for-place/${id}`, {
			memberId: user._id
		});
		console.log('DatingEventEdit: Sent email:', data);
		alert('Email sent successfully');
	};

	const getMatchedMember = (memberId: string) => {
		if (!memberId) return undefined;
		return combinedInvitationMembers?.find(member => getMemberIdentifier(member) === memberId);
	};

	const addMatch = () => {
		setInvitationMatchedList(prev => [...prev, { memberId: '', memberMatchId: '', number: 1 }]);
	};

	const removeMatch = (index: number) => {
		setInvitationMatchedList(prev => prev.filter((_, i) => i !== index));
	};

	const updateMatch = (index: number, field: string, value: any) => {
		setInvitationMatchedList(prev => {
			const updated = [...prev];
			updated[index] = { ...updated[index], [field]: value };
			return updated;
		});
	};

	const saveMatches = async () => {
		try {
			const { data } = await axios.post(`${constants.API_URL}/dating-events/save-matches`, {
				invitationMatchedList: invitationMatchedList,
				datingEventId: id
			});
			console.log('DatingEventEdit: Saved matches:', data);
			notify('הזוגות נשמרו בהצלחה', { type: 'success' });
		} catch (error) {
			console.error('Error saving matches:', error);
			notify('שגיאה בשמירת הזוגות', { type: 'error' });
		}
	};

	const dating_event_id = useGetRecordId();
	return (
		<Edit resource="dating-events">
			<SimpleForm key={record?.id || 'loading'}>

				<Grid item xs={12}>
					<Button
						variant="contained"
						color="primary"
						onClick={async () => {
							try {
								const response = await axios.post(
									`${constants.API_URL}/dating-events/export-event-data/${id}`,
									{},
									{
										responseType: 'blob'
									}
								);
								
								// Create blob link to download
								const url = window.URL.createObjectURL(new Blob([response.data]));
								const link = document.createElement('a');
								link.href = url;
								link.setAttribute('download', `event-data-${id}.xlsx`);
								
								// Append to html link element page
								document.body.appendChild(link);
								
								// Start download
								link.click();
								
								// Clean up and remove the link
								link.parentNode?.removeChild(link);
								
								notify('הקובץ הורד בהצלחה', { type: 'success' });
							} catch (error) {
								console.error('Error exporting data:', error);
								notify('שגיאה בייצוא הנתונים', { type: 'error' });
							}
						}}
						startIcon={<GetApp />}
						sx={{ mb: 2 }}
					>
						ייצא נתונים לאקסל
					</Button>
				</Grid>
			<Grid spacing={2} container>
				<Grid item sm={6}>
					<TextInput source="title" fullWidth label="כותרת עברית" dir="rtl" />
				</Grid>
				<Grid item sm={6}>
					<TextInput source="title_english" fullWidth label="כותרת אנגלית" dir="ltr" />
				</Grid>
				<Box width="100%" />

				<Grid item sm={6}>
					<TextInput source="sub_title" fullWidth label="כותרת משנה עברית" dir="rtl" />
				</Grid>
				<Grid item sm={6}>
					<TextInput source="sub_title_english" fullWidth label="כותרת משנה אנגלית" dir="ltr" />
				</Grid>
				<Box width="100%" />
				
				<Grid item sm={12}>
					<BooleanInput source="happy_hour" fullWidth label="happy hour"  dir="rtl" />
				</Grid>
				<Grid item sm={12}>
					<TextInput source="description.he" fullWidth label="תיאור" multiline dir="rtl" />
				</Grid>
				<Grid item sm={12}>
					<BooleanInput source="isPreview" fullWidth label="ארוע טיזר?  " />
				</Grid>
				<Box width="100%" />
				<Grid item sm={12}>
					<TextInput source="lat" fullWidth label="latitude" dir="rtl" />
				</Grid>
				<Grid item sm={12}>
					<TextInput source="lng" fullWidth label="longitude" dir="rtl" />
				</Grid>
				<Box width="100%" />
				<Grid item sm={12}>
					<TextInput source="price" fullWidth label="price" dir="rtl" />
				</Grid>
				<Box width="100%" />
				<Grid item sm={6}>
					<TextInput 
						source="time" 
						fullWidth 
						label="תאריך ושעה" 
						type="datetime-local"
						helperText="בחר תאריך ושעה"
						parse={(value) => {
							// Convert local datetime to ISO string for server
							return value ? new Date(value).toISOString() : null;
						}}
						format={(value) => {
							// Convert ISO string to local datetime for input
							if (!value) return '';
							try {
								const date = new Date(value);
								// Format as YYYY-MM-DDTHH:mm (local timezone)
								const year = date.getFullYear();
								const month = String(date.getMonth() + 1).padStart(2, '0');
								const day = String(date.getDate()).padStart(2, '0');
								const hours = String(date.getHours()).padStart(2, '0');
								const minutes = String(date.getMinutes()).padStart(2, '0');
								return `${year}-${month}-${day}T${hours}:${minutes}`;
							} catch (error) {
								console.error('Error formatting date:', error);
								return '';
							}
						}}
					/>
				</Grid>
				<Grid item sm={6}>
					<TextInput source="address" fullWidth label="כתובת" dir="rtl" />
				</Grid>

				<Grid item sm={6}>
					<TextInput source="address_english" fullWidth label="כתובת באנגלית" dir="rtl" />
				</Grid>

				<Grid item sm={6}>
					<TextInput source="duration" fullWidth label="זמן משך (דקות)" dir="rtl" />
				</Grid>
				<Box width="100%" />
				<Grid item sm={6}>
					<NumberInput source="limitInvatations" fullWidth label="מספר הזמנות מקסימלי" />
				</Grid>
				<Grid item sm={6}>
					<BooleanInput source="isActive" fullWidth label="פעיל" />
				</Grid>

				<Box width="100%" />
				<Grid item sm={12}>
					</Grid>

					<Typography variant="h6" sx={{ mt: 2, mb: 1 }} > תמונת פלאח  </Typography>
							<Grid item xs={2}>
								<ImageField source="banner" label=" תמונת פלאח " />
							</Grid>
				<Grid item xs={12}>
					<ImageInput 
						source="banner" 
						label="העלאת תמונת פלאח"
						accept="image/*"
						onChange={(event: any) => {
							console.log('onChange triggered');
							const files = event?.target?.files || event;
							console.log('Files:', files);
							
							if (!files) {
								console.log('No files selected');
								return;
							}

							(async () => {
								try {
									const token = localStorage.getItem('token');
									if (!token) {
										notify('No authentication token found', { type: 'error' });
										return;
									}

									const formData = new FormData();
									formData.append('image', files);
									formData.append('datingEvent_id', dating_event_id.toString());
									formData.append('type','banner');
									
								
									await axios.post(`${constants.API_URL}dating-events/upload_image`, formData, {
										headers: {
											'Authorization': `Bearer ${token}`,
											'Accept': 'application/json'
										},
									});
									
									notify('תמונת רקע הועלתה בהצלחה', { type: 'success' });
									
								} catch (error) {
									console.error('Error uploading image:', error);
								
								}
							})();
						}}
					>
						<ImageField source="src" />
					</ImageInput>
				</Grid>
				<Box width="100%" />

				<Typography variant="h6" sx={{ mt: 2, mb: 1 }} > תמונת פופאפ  </Typography>
							<Grid item xs={2}>
								<ImageField source="popupBanner" label=" תמונת פופאפ " />
							</Grid>
				<Grid item xs={12}>
					<ImageInput 
						source="popupBanner" 
						label="העלאת תמונת פופאפ"
						accept="image/*"
						onChange={(event: any) => {
							console.log('onChange triggered');
							const files = event?.target?.files || event;
							console.log('Files:', files);
							
							if (!files) {
								console.log('No files selected');
								return;
							}

							(async () => {
								try {
									const token = localStorage.getItem('token');
									if (!token) {
										notify('No authentication token found', { type: 'error' });
										return;
									}

									const formData = new FormData();
									formData.append('image', files);
									formData.append('datingEvent_id', dating_event_id.toString());
									formData.append('type','popupBanner');
									
								
									await axios.post(`${constants.API_URL}dating-events/upload_image`, formData, {
										headers: {
											'Authorization': `Bearer ${token}`,
											'Accept': 'application/json'
										},
									});
									
									notify('תמונת רקע הועלתה בהצלחה', { type: 'success' });
									
								} catch (error) {
									console.error('Error uploading image:', error);
								
								}
							})();
						}}
					>
						<ImageField source="src" />
					</ImageInput>
				</Grid>
				<Box width="100%" />
				
				{/* Gender Statistics Table */}
				<Grid item xs={12}>
					<Typography variant="h6" gutterBottom>סטטיסטיקת מגדר</Typography>
				</Grid>
				<Grid item xs={12}>
					<TableContainer component={Paper} elevation={2}>
						<Table>
							<TableHead>
								<TableRow>
									<TableCell align="center"><strong>מגדר</strong></TableCell>
									<TableCell align="center"><strong>מספר משתתפים</strong></TableCell>
									<TableCell align="center"><strong>מחפשים</strong></TableCell>
									<TableCell align="right"><strong>רשימת אימיילים</strong></TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								<TableRow>
									<TableCell align="center">גברים</TableCell>
									<TableCell align="center">{getGenderStats().males}</TableCell>
									<TableCell align="center" dir="rtl" sx={{ fontSize: '0.85rem' }}>
										{getGenderStats().maleInterests.join(', ') || 'אין'}
									</TableCell>
									<TableCell align="right" dir="ltr" sx={{ fontSize: '0.85rem' }}>
										{getGenderStats().maleEmails.join(', ') || 'אין'}
									</TableCell>
								</TableRow>
								<TableRow>
									<TableCell align="center">נשים</TableCell>
									<TableCell align="center">{getGenderStats().females}</TableCell>
									<TableCell align="center" dir="rtl" sx={{ fontSize: '0.85rem' }}>
										{getGenderStats().femaleInterests.join(', ') || 'אין'}
									</TableCell>
									<TableCell align="right" dir="ltr" sx={{ fontSize: '0.85rem' }}>
										{getGenderStats().femaleEmails.join(', ') || 'אין'}
									</TableCell>
								</TableRow>
								<TableRow>
									<TableCell align="center">ללא מגדר</TableCell>
									<TableCell align="center">{getGenderStats().noGender}</TableCell>
									<TableCell align="center" dir="rtl" sx={{ fontSize: '0.85rem' }}>
										{getGenderStats().noGenderInterests.join(', ') || 'אין'}
									</TableCell>
									<TableCell align="right" dir="ltr" sx={{ fontSize: '0.85rem' }}>
										{getGenderStats().noGenderEmails.join(', ') || 'אין'}
									</TableCell>
								</TableRow>
								<TableRow>
									<TableCell align="center"><strong>סה"כ</strong></TableCell>
									<TableCell align="center"><strong>{getGenderStats().total}</strong></TableCell>
									<TableCell align="center"></TableCell>
									<TableCell align="right"></TableCell>
								</TableRow>
							</TableBody>
						</Table>
					</TableContainer>
				</Grid>
				<Box width="100%" />
				
				{/* Invitation Lists Management */}
				<Grid item xs={12}>
					<Typography variant="h6" gutterBottom>ניהול הזמנות</Typography>
				</Grid>
				
				<Grid item xs={12} md={6}>
					<Paper elevation={2} sx={{ p: 2, maxHeight: 400, overflow: 'auto' }}>
						<Typography variant="subtitle1" gutterBottom>
							רשימת הזמנות מאושרות ({invitationList?.length || 0})
						</Typography>
						<List dense>
							{invitationList?.map((user: any, index: number) => (
								<ListItem
									key={user._id || user.id || index}
									secondaryAction={
										<IconButton
											edge="end"
											onClick={() => moveToWaitingList(index)}
											title="העבר לרשימת המתנה"
										>
											<ArrowBack />
										</IconButton>
									}
								>
									<Person sx={{ mr: 1, color: 'success.main' }} />
									<ListItemText
										primary={getUserDisplayName(user)}
										secondary={getUserDetails(user)}
									/>
								</ListItem>
							))}
							{(!invitationList || invitationList.length === 0) && (
								<ListItem>
									<ListItemText
										primary="אין הזמנות מאושרות"
										secondary="המשתמשים יופיעו כאן לאחר אישור"
									/>
								</ListItem>
							)}
						</List>
					</Paper>
				</Grid>
				
				<Grid item xs={12} md={6}>
					<Paper elevation={2} sx={{ p: 2, maxHeight: 400, overflow: 'auto' }}>
						<Typography variant="subtitle1" gutterBottom>
							רשימת המתנה ({invitationWatingList?.length || 0})
						</Typography>
						<List dense>
							{invitationWatingList?.map((user: any, index: number) => (
								<ListItem
									key={user._id || user.id || index}
									secondaryAction={
										<>
										
										<IconButton
											edge="end"
											onClick={() => moveToConfirmedList(index)}
											title="אשר הזמנה"
										>
											<ArrowForward />
										</IconButton>
										
										<IconButton
										style={{ marginRight: 5,marginLeft: 5 }}
											edge="end"
											onClick={() => sendEmail(index)}
											title="שליחת מייל על מקום שהתפנה"
										>
											<Email />
										</IconButton>
										</>
										
									}
								>
									
									<ListItemText
										primary={getUserDisplayName(user)}
										secondary={getUserDetails(user)}
									/>
								</ListItem>
							))}
							{(!invitationWatingList || invitationWatingList.length === 0) && (
								<ListItem>
									<ListItemText
										primary="אין משתמשים ברשימת המתנה"
										secondary="המשתמשים יופיעו כאן לאחר הרשמה"
									/>
								</ListItem>
							)}
						</List>
					</Paper>
				</Grid>

				{/* Matched Couples Section */}
				<Grid item xs={12}>
					<Typography variant="h6" gutterBottom>ניהול זוגות</Typography>
				</Grid>
				<Grid item xs={12}>
					<Paper elevation={2} sx={{ p: 2 }}>
						<Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
							<Typography variant="subtitle1">
								זוגות מועדים ({invitationMatchedList.length})
							</Typography>
							<Button 
								variant="contained" 
								color="primary" 
								size="small"
								startIcon={<Add />}
								onClick={addMatch}
							>
								הוסף זוג
							</Button>
						</Box>
						<TableContainer>
							<Table size="small">
								<TableHead>
									<TableRow>
										<TableCell align="center"><strong>מספר</strong></TableCell>
										<TableCell align="right"><strong>חבר 1</strong></TableCell>
										<TableCell align="right"><strong>חבר 2</strong></TableCell>
										<TableCell align="center"><strong>מספור</strong></TableCell>
										<TableCell align="center"><strong>פעולות</strong></TableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									{invitationMatchedList.map((match, index) => {
										const member1 = getMatchedMember(match.memberId);
										const member2 = getMatchedMember(match.memberMatchId);
										return (
											<TableRow key={index}>
												<TableCell align="center">{index + 1}</TableCell>
												<TableCell>
													<FormControl fullWidth size="small">
														<Select
															value={match.memberId || ''}
															onChange={(e) => updateMatch(index, 'memberId', e.target.value)}
															displayEmpty
															renderValue={(value) => {
																if (!value) return <em>בחר חבר</em>;
																const selectedMember = combinedInvitationMembers?.find(m => getMemberIdentifier(m) === value);
																if (!selectedMember) return value;
																const displayName = typeof selectedMember === 'string' 
																	? selectedMember 
																	: getUserDisplayName(selectedMember);
																const imageUri = typeof selectedMember === 'object' ? selectedMember.imageUri : null;
																return (
																	<Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
																		{imageUri && (
																			<Avatar 
																				src={imageUri} 
																				alt={displayName}
																				sx={{ width: 48, height: 48 }}
																			/>
																		)}
																		{!imageUri && (
																			<Avatar sx={{ width: 48, height: 48 }}>
																				{displayName?.charAt(0)?.toUpperCase() || '?'}
																			</Avatar>
																		)}
																		<span>{displayName}</span>
																	</Box>
																);
															}}
														>
															<MenuItem value=""><em>בחר חבר</em></MenuItem>
															{combinedInvitationMembers?.map((member, idx) => {
																const memberId = getMemberIdentifier(member);
																const isMatched = memberId ? matchedMemberIds.has(memberId) : false;
																const displayName = typeof member === 'string' 
																	? member 
																	: getUserDisplayName(member);
																const imageUri = typeof member === 'object' ? member.imageUri : null;
																const gender = typeof member === 'object' ? member.gender : null;
																const interests = typeof member === 'object' ? member.dating_profile?.interests : null;
																const genderDisplay = gender === 'M' ? 'גבר' : gender === 'F' ? 'אישה' : gender || 'לא צוין';
																return (
																	<MenuItem
																		key={memberId || idx}
																		value={memberId}
																		sx={{
																			backgroundColor: isMatched ? 'rgba(25, 118, 210, 0.08)' : undefined
																		}}
																	>
																		<Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, width: '100%' }}>
																			{imageUri && (
																				<Avatar 
																					src={imageUri} 
																					alt={displayName}
																					sx={{ width: 56, height: 56 }}
																				/>
																			)}
																			{!imageUri && (
																				<Avatar sx={{ width: 56, height: 56 }}>
																					{displayName?.charAt(0)?.toUpperCase() || '?'}
																				</Avatar>
																			)}
																			<Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
																				<Typography variant="body1" sx={{ fontWeight: 500 }}>
																					{displayName}
																				</Typography>
																				<Typography variant="body2" sx={{ color: 'text.secondary' }}>
																					{genderDisplay} {interests ? `• ${interests}` : ''}
																				</Typography>
																				{isMatched && (
																					<Typography variant="caption" sx={{ color: 'text.secondary' }}>
																						כבר משויך
																					</Typography>
																				)}
																			</Box>
																		</Box>
																	</MenuItem>
																);
															})}
														</Select>
													</FormControl>
												</TableCell>
												<TableCell>
													<FormControl fullWidth size="small">
														<Select
															value={match.memberMatchId || ''}
															onChange={(e) => updateMatch(index, 'memberMatchId', e.target.value)}
															displayEmpty
															renderValue={(value) => {
																if (!value) return <em>בחר חבר</em>;
																const selectedMember = combinedInvitationMembers?.find(m => getMemberIdentifier(m) === value);
																if (!selectedMember) return value;
																const displayName = typeof selectedMember === 'string' 
																	? selectedMember 
																	: getUserDisplayName(selectedMember);
																const imageUri = typeof selectedMember === 'object' ? selectedMember.imageUri : null;
																return (
																	<Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
																		{imageUri && (
																			<Avatar 
																				src={imageUri} 
																				alt={displayName}
																				sx={{ width: 48, height: 48 }}
																			/>
																		)}
																		{!imageUri && (
																			<Avatar sx={{ width: 48, height: 48 }}>
																				{displayName?.charAt(0)?.toUpperCase() || '?'}
																			</Avatar>
																		)}
																		<span>{displayName}</span>
																	</Box>
																);
															}}
														>
															<MenuItem value=""><em>בחר חבר</em></MenuItem>
															{combinedInvitationMembers?.map((member, idx) => {
																const memberId = getMemberIdentifier(member);
																const isMatched = memberId ? matchedMemberIds.has(memberId) : false;
																const displayName = typeof member === 'string' 
																	? member 
																	: getUserDisplayName(member);
																const imageUri = typeof member === 'object' ? member.imageUri : null;
																const gender = typeof member === 'object' ? member.gender : null;
																const interests = typeof member === 'object' ? member.dating_profile?.interests : null;
																const genderDisplay = gender === 'M' ? 'גבר' : gender === 'F' ? 'אישה' : gender || 'לא צוין';
																return (
																	<MenuItem
																		key={memberId || idx}
																		value={memberId}
																		sx={{
																			backgroundColor: isMatched ? 'rgba(25, 118, 210, 0.08)' : undefined
																		}}
																	>
																		<Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, width: '100%' }}>
																			{imageUri && (
																				<Avatar 
																					src={imageUri} 
																					alt={displayName}
																					sx={{ width: 56, height: 56 }}
																				/>
																			)}
																			{!imageUri && (
																				<Avatar sx={{ width: 56, height: 56 }}>
																					{displayName?.charAt(0)?.toUpperCase() || '?'}
																				</Avatar>
																			)}
																			<Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
																				<Typography variant="body1" sx={{ fontWeight: 500 }}>
																					{displayName}
																				</Typography>
																				<Typography variant="body2" sx={{ color: 'text.secondary' }}>
																					{genderDisplay} {interests ? `• ${interests}` : ''}
																				</Typography>
																				{isMatched && (
																					<Typography variant="caption" sx={{ color: 'text.secondary' }}>
																						כבר משויך
																					</Typography>
																				)}
																			</Box>
																		</Box>
																	</MenuItem>
																);
															})}
														</Select>
													</FormControl>
												</TableCell>
												<TableCell>
													<TextField
														type="number"
														size="small"
														value={match.number || 1}
														onChange={(e) => updateMatch(index, 'number', parseInt(e.target.value) || 1)}
														inputProps={{ min: 1 }}
													/>
												</TableCell>
												<TableCell align="center">
													<IconButton color="error" onClick={() => removeMatch(index)}>
														<DeleteOutline />
													</IconButton>
												</TableCell>
											</TableRow>
										);
									})}
									{invitationMatchedList.length === 0 && (
										<TableRow>
											<TableCell colSpan={5} align="center">
												אין זוגות. לחץ על "הוסף זוג" כדי להתחיל.
											</TableCell>
										</TableRow>
									)}
								</TableBody>
							</Table>
						</TableContainer>
						{invitationMatchedList.length > 0 && (
							<Box display="flex" justifyContent="center" mt={2}>
								<Button 
									variant="contained" 
									color="primary"
									onClick={saveMatches}
								>
									שמור זוגות
								</Button>
							</Box>
						)}
					</Paper>
				</Grid>

				<Grid item xs={12}>
					<Typography variant="h6" gutterBottom> רשימה של אישרו הגעה</Typography>
				</Grid>

				<Grid item xs={12} md={6}>
					<Paper elevation={2} sx={{ p: 2, maxHeight: 400, overflow: 'auto' }}>
						<Typography variant="subtitle1" gutterBottom>
						רשימת המשתמשים שאישרו הגעה ({invitationConfirmedList?.length || 0})
						</Typography>
						<List dense>
							{invitationConfirmedList?.map((user: any, index: number) => (
								<ListItem
									key={user._id || user.id || index}
									secondaryAction={
										<>
										
										
										
										
										</>
										
									}
								>
									
									<ListItemText
										primary={getUserDisplayName(user)}
										secondary={getUserDetails(user)}
									/>
								</ListItem>
							))}
							{(!invitationConfirmedList || invitationConfirmedList.length === 0) && (
								<ListItem>
									<ListItemText
										primary="אין משתמשים ברשימת המתנה"
										secondary="המשתמשים יופיעו כאן לאחר הרשמה"
									/>
								</ListItem>
							)}
						</List>
					</Paper>
				</Grid>
				
				{/* External Registers List */}
				<Grid item xs={12}>
					<Typography variant="h6" gutterBottom>רשימת רישומים חיצוניים</Typography>
				</Grid>

				<Grid item xs={12} md={6}>
					<Paper elevation={2} sx={{ p: 2, maxHeight: 400, overflow: 'auto' }}>
						<Typography variant="subtitle1" gutterBottom>
							רשימת רישומים חיצוניים ({externalRegisters?.length || 0})
						</Typography>
						<List dense>
							{externalRegisters?.map((member: any, index: number) => (
								<ListItem
									key={member._id || member.id || index}
								>
									<Person sx={{ mr: 1, color: 'info.main' }} />
									<ListItemText
										primary={member.name || 'ללא שם'}
										secondary={member.email || 'ללא אימייל'}
									/>
								</ListItem>
							))}
							{(!externalRegisters || externalRegisters.length === 0) && (
								<ListItem>
									<ListItemText
										primary="אין רישומים חיצוניים"
										secondary="הרישומים החיצוניים יופיעו כאן"
									/>
								</ListItem>
							)}
						</List>
					</Paper>
				</Grid>
				{/* Save Button */}
				<Grid item xs={12}>
					<Box display="flex" justifyContent="center" mt={3}>
						{/* <Button
							variant="contained"
							color="primary"
							size="large"
							onClick={saveLists}
							startIcon={<PersonAdd />}
							sx={{
								minWidth: 200,
								py: 1.5,
								px: 4,
								fontSize: '1.1rem',
								fontWeight: 'bold',
								borderRadius: 2,
								boxShadow: 3,
								'&:hover': {
									boxShadow: 6,
									transform: 'translateY(-2px)',
									transition: 'all 0.2s ease-in-out'
								}
							}}
						>
							שמור שינויים ברשימות
						</Button> */}
					</Box>
				</Grid>
			</Grid>
		</SimpleForm>
		</Edit>
	);
};

export default DatingEventEdit;
